import { __exportAll } from "../../../_virtual/_rolldown/runtime.js";
import { createElementBlock, createElementVNode, openBlock } from "vue";
//#region src/components/ScalarIcon/icons/Download.svg?component
var Download_exports = /* @__PURE__ */ __exportAll({
	default: () => Download_default,
	render: () => render$1
});
var _hoisted_1 = {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	stroke: "currentColor",
	"stroke-linecap": "round",
	"stroke-linejoin": "round",
	viewBox: "0 0 24 24"
};
function render$1(_ctx, _cache) {
	return openBlock(), createElementBlock("svg", _hoisted_1, [..._cache[0] || (_cache[0] = [createElementVNode("path", { d: "M12.001 3.75v12m-4.5-4.5 4.5 4.5 4.5-4.5m6.75 4.5v1.5a3 3 0 0 1-3 3h-16.5a3 3 0 0 1-3-3v-1.5" }, null, -1)])]);
}
var Download_default = { render: render$1 };
//#endregion
export { Download_exports, Download_default as default, render$1 as render };

//# sourceMappingURL=Download.svg.virtual.js.map